/**
 * Der Rahmen: Kopfzeile mit Aktenzeichen, Inhalt im Lichtkegel, unten die
 * Messingschiene mit vier Registern.
 */
import { NavLink, Outlet } from 'react-router-dom'
import { useSitzung } from '../api/sitzung.js'
import { VorladungsWache } from './Vorladungen.js'

const REGISTER = [
  { pfad: '/', label: 'Akte', ende: true },
  { pfad: '/termine', label: 'Termine', ende: false },
  { pfad: '/konto', label: 'Konto', ende: false },
  { pfad: '/gesetz', label: 'Gesetz', ende: false },
] as const

export function Layout() {
  const { mitglied, meldeAb } = useSitzung()

  return (
    <div className="relative z-10 mx-auto flex min-h-dvh max-w-spalte flex-col px-5 pt-6 pb-24">
      <header className="flex items-baseline justify-between gap-3">
        <p className="protokoll">
          StrSchGb · {mitglied ? `${mitglied.avatarEmoji} ${mitglied.name}` : 'Az. unbekannt'}
        </p>
        <button
          type="button"
          onClick={meldeAb}
          className="protokoll normal-case underline decoration-messing/40 underline-offset-4 hover:text-messing"
        >
          Abmelden
        </button>
      </header>
      <hr className="haarlinie mt-3" />

      <main className="flex-1">
        <Outlet />
      </main>

      <VorladungsWache />

      <nav
        aria-label="Hauptnavigation"
        className="fixed inset-x-0 bottom-0 z-20 border-t border-messing/40 bg-saal/95 backdrop-blur"
      >
        <div className="mx-auto flex max-w-spalte">
          {REGISTER.map((r) => (
            <NavLink
              key={r.pfad}
              to={r.pfad}
              end={r.ende}
              className={({ isActive }) =>
                `registerreiter flex-1 py-3.5 text-center font-sans text-xs font-semibold tracking-widest uppercase transition-colors ${
                  isActive ? 'text-lampe' : 'text-akte/50 hover:text-akte'
                }`
              }
              data-aktiv={undefined}
            >
              {({ isActive }) => (
                <span
                  className="relative inline-block px-1"
                  ref={(el) => {
                    // Der Registerreiter im Kanzlei-Gewand braucht den Zustand
                    // am Element selbst — NavLink gibt ihn nur hier heraus.
                    el?.closest('a')?.setAttribute('data-aktiv', isActive ? 'ja' : 'nein')
                  }}
                >
                  {r.label}
                  {isActive && (
                    <span
                      aria-hidden="true"
                      className="absolute -top-3.5 left-0 h-0.5 w-full bg-messing"
                    />
                  )}
                </span>
              )}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  )
}
